import React from 'react';

const DashboardCard = ({ title, value, subtitle, icon, loading, error, onClick, variant = 'primary' }) => (
  <button type="button" className={`dashboard-kpi-card dashboard-kpi-${variant}`} onClick={onClick} disabled={!onClick}>
    <div className="dashboard-kpi-top">
      <span className="dashboard-kpi-icon">{icon}</span>
      <span className="dashboard-kpi-title">{title}</span>
    </div>
    {loading ? <div className="dashboard-skeleton-line w-50" /> : <div className="dashboard-kpi-value">{value}</div>}
    <div className={`dashboard-kpi-subtitle ${error ? 'text-danger' : ''}`}>{loading ? 'Loading...' : error || subtitle}</div>
  </button>
);

export default DashboardCard;
